import React from 'react';

import type { CodeBlockRedlineEditError } from '@aline/common';
import { Typography } from '@mui/material';
import { ErrorIcon } from 'src/components/icons/ErrorIcon';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  contentContainer: {
    flex: '1 1 auto',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  location: {
    color: theme.palette.text.secondary,
    fontFamily: 'monospace',
    fontSize: 10,
    marginTop: theme.spacing(0.5),
  },
  message: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  root: {
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: 8,
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
  },
}));

/**
 * Renders a single redline-edit application failure (server could not apply
 * the AI's edit to the document) as a non-actionable error row inside the
 * redline list.
 */
export const RedlineErrorItem = React.memo(function RedlineErrorItem({
  error,
}: {
  error: CodeBlockRedlineEditError;
}): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.iconContainer}>
        <ErrorIcon style={{ height: 18, width: 18 }} />
      </div>
      <div className={classes.contentContainer}>
        <Typography className={classes.title}>Could not apply suggestion</Typography>
        <Typography className={classes.message}>{error.message}</Typography>
        <Typography className={classes.location}>
          {error.documentId} · {error.locationAnchor}
        </Typography>
      </div>
    </div>
  );
});
